import { Link } from "react-router-dom";
import { getCategories } from "../../api/apiServices";
import { slugify } from "../../utils/slugify";

export default function Footer() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
        const loadData = async () => {
          try {
            setLoading(true);
    
            const [categoriesRes] = await Promise.all([
              getCategories(),
            ]);
    
            setCategories(categoriesRes.data || []);
          } catch (err) {
            console.error("Failed to load shop data:", err);
          } finally {
            setLoading(false);
          }
        };
    
        loadData();
      }, []);

  return (
    <>
      <footer className="w-full bg-[#FDF2F6] mt-16">
        <div className="max-w-[1200px] mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

            {/* BRAND */}
            <div>
              <h2 className="font-['Playfair_Display'] text-3xl font-bold text-[#EF579A] mb-4">
                SISI
              </h2>

              <p className="text-gray-600 text-sm font-['Poppins'] leading-relaxed">
                Affordable fashion for the modern woman. Look stunning without breaking the bank.
              </p>

              {/* SOCIALS */}
              <div className="flex gap-3 mt-5">
                <a
                  href="https://instagram.com/sisi.nig"
                  target="_blank"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EF579A] text-white hover:bg-[#d94a87]"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>

                <a
                  href="https://facebook.com/sisi.nig"
                  target="_blank"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EF579A] text-white hover:bg-[#d94a87]"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
              </div>
            </div>

            {/* SHOP */}
<div>
  <h3 className="font-['Poppins'] font-semibold text-gray-800 mb-4">
    Shop
  </h3>

  <ul className="space-y-2.5">
    {categories.slice(0, 6).map((category) => (
      <li key={category.slug}>
        <Link
          to={`/products/${slugify(category.name)}`}
          className="text-gray-600 text-sm font-['Poppins'] hover:text-[#EF579A]"
        >
          {category.name}
        </Link>
      </li>
    ))}
  </ul>

  {/* Optional: Show All Link */}
  {categories.length > 6 && (
    <div className="mt-3">
      <Link
        to="/products"
        className="text-xs text-[#EF579A] font-medium hover:underline"
      >
        View all categories →
      </Link>
    </div>
  )}
</div>


            {/* CONTACT */}
            <div>
              <h3 className="font-['Poppins'] font-semibold text-gray-800 mb-4">
                Contact Us
              </h3>

              <div className="space-y-3 text-sm font-['Poppins'] text-gray-600">

                <p className="flex gap-2 items-start">
                  <i className="ri-whatsapp-line text-[#25D366] text-lg"></i>
                  <a href="https://wa.me/2348066221327" target="_blank" className="hover:text-[#EF579A]">
                    08066221327
                  </a>
                </p>

                <p className="flex gap-2 items-start">
                  <i className="ri-phone-line text-lg"></i>
                  <a href="tel:08066221327" className="hover:text-[#EF579A]">
                    Call: 08066221327
                  </a>
                </p>

                <p className="flex gap-2 items-start">
                  <i className="ri-mail-line text-lg"></i>
                  <a href="mailto:sisi.ngcontact@gmail.com" className="hover:text-[#EF579A] break-all">
                    sisi.ngcontact@gmail.com
                  </a>
                </p>

                <p className="flex gap-2 items-start">
                  <i className="ri-instagram-line text-lg"></i>
                  <a href="https://instagram.com/sisi.nig" target="_blank" className="hover:text-[#EF579A]">
                    @sisi.nig
                  </a>
                </p>

                <p className="flex gap-2 items-start">
                  <i className="ri-facebook-fill text-lg"></i>
                  <a href="https://facebook.com/sisi.nig" target="_blank" className="hover:text-[#EF579A]">
                    @sisi.nig
                  </a>
                </p>

              </div>
            </div>

          </div>

          <div className="border-t border-pink-200 mt-10 pt-6 text-center">
            <p className="text-gray-500 text-xs font-['Poppins']">
              © {new Date().getFullYear()} SISI. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* FLOATING WHATSAPP BUTTON */}
      <a
        href="https://wa.me/2348066221327?text=Hello%20SISI%2C%20I%20want%20to%20make%20an%20enquiry"
        target="_blank"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:scale-105 transition-transform"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
        <span className="hidden sm:inline font-medium">Chat with us</span>
      </a>
    </>
  );
}
